import { ProductVariantDTO } from "../models/product/product.request";

export const validateEmail = (email: string): string | null => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if(!email){
        return "Email is required.";
    }
    if (!emailRegex.test(email)) {
        return "Invalid email format.";
    }
    return null;

}

export const validatePassword = (password: string): string | null => {

    if(!password){
        return "Password is required.";
    }

    let passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/; // Minimum six characters, at least one letter and one number

    if (!passwordRegex.test(password)) {
        return "Password must be at least 6 characters long and contain at least one letter and one number.";
    }

    return null;
}

export const validatePhoneNumber = (phoneNumber: string): string | null => {

    if(!phoneNumber){
        return "Phone number is required.";
    }

    let phoneRegex = /^\+?[0-9]\d{7,14}$/; // E.164 format

    if (!phoneRegex.test(phoneNumber)) {
        return "Invalid phone number format.";
    }

    return null;
}

export const validateMenuItemName = (name: string): string | null => {

    if(!name){
        return "Ime stavke je obavezno.";
    }

    if (name.length < 3 || name.length > 40) {
        return "Ime stavke mora biti između 3 i 40 karaktera.";
    }

    return null;
}

export function validateMenuItemProductVariants(variants: ProductVariantDTO[]): string | null {

    if (!variants || variants.length === 0) {
        return "Mora postojati barem jedna varijanta proizvoda.";
    }

    for (let i = 0; i < variants.length; i++) {
        const variant = variants[i];
        if (!variant.label || variant.label.trim() === "") {
            return `Varijanta proizvoda na poziciji ${i + 1} nema naziv.`;
        }
        if (variant.price === undefined || variant.price <= 0) {
            return `Varijanta proizvoda "${variant.label}" poziciji ${i + 1} ima neispravnu cijenu.`;
        }

        if(variant.oldPrice && variant.oldPrice < variant.price){
            return `Varijanta proizvoda "${variant.label}" poziciji ${i + 1} ima veću akcijsku cenu od standardne.`
        }
    }

    return null;
}